import { render, staticRenderFns } from "./OwalSpinnerLogo.vue?vue&type=template&id=ffb5df8e&scoped=true"
import script from "./OwalSpinnerLogo.vue?vue&type=script&lang=js"
export * from "./OwalSpinnerLogo.vue?vue&type=script&lang=js"
import style0 from "./OwalSpinnerLogo.vue?vue&type=style&index=0&id=ffb5df8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb5df8e",
  null
  
)

export default component.exports